import React from 'react';

export default function ContainerLayout({children}) {
  return <div className="container pt-2 pt-lg-3">{children}</div>;
}
